<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('company')"
          :rules="getValidationRule('required')"
          prop="companyID"
          class="material-style">
          <select-company
            :model.sync="form.companyID"
            @update:model="updateModelItem('companyID', { required: true })"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('name')"
          prop="name"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="secondField"
            :value="form.name"
            @input="form.name = valueTrimLeft($event)"
            @change="updateModelItem('name', { required: true })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('email')"
          prop="email"
          :rules="ruleEmail"
          class="material-style">
          <el-input
            ref="fourthField"
            :value="form.email"
            @input="form.email = valueTrimLeft($event)"
            @change="updateModelItem('email', { required: true, rules: ruleEmail })"/>
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('phone')"
          prop="phone"
          class="material-style">
          <el-input
            ref="sixthField"
            :value="form.phone"
            @input="form.phone = valueTrimLeft($event)"
            @change="updateModelItem('phone', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('division')"
          prop="divisionID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.divisionID"
            @update:model="updateModelItem('divisionID', { required: true })"
            :data="dataSourceDivision.records"
            :isLoading="dataSourceDivision.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('mobile')"
          prop="mobile"
          class="material-style">
          <el-input
            ref="seventhField"
            :value="form.mobile"
            @input="form.mobile = valueTrimLeft($event)"
            @change="updateModelItem('mobile', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('phone-2')"
          prop="phone2"
          class="material-style">
          <el-input
            ref="sixthField"
            :value="form.phone2"
            @input="form.phone2 = valueTrimLeft($event)"
            @change="updateModelItem('phone2', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('fax')"
          prop="fax"
          class="material-style">
          <el-input
            ref="eighthField"
            :value="form.fax"
            @input="form.fax = valueTrimLeft($event)"
            @change="updateModelItem('fax', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('title')"
          prop="title"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.title"
            @input="form.title = valueTrimLeft($event)"
            @change="updateModelItem('title',{ required: false })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        <el-form-item
          :label="L10n('remark')"
          prop="remark"
          class="material-style">
          <el-input
            ref="eighthField"
            type="textarea"
            :rows="3"
            :value="form.remark"
            @input="form.remark = valueTrimLeft($event)"
            @change="updateModelItem('remark', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { ServiceContacts } from '@/services/Contacts'

export default {
  name: 'FormContacts',
  mixins: [Form],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceDivision () {
      return this.API('Divisions/GetAllDynamic?select=id,title')
    },
    ruleEmail () {
      return [
        ...this.getValidationRule('required,email'),
        {
          trigger: ['blur'],
          validator: this.validateEmail
        }
      ]
    }
  },
  methods: {
    async validateEmail (rule, value, cb) {
      try {
        if (this.data.email === this.form.email) {
          return cb()
        }
        await ServiceContacts
          .checkEmail({ email: value })
        cb()
      } catch (e) {
        cb(e)
      }
    }
  }
}
</script>
